import { ClickAwayListener } from '@material-ui/core';
import React from 'react';
import { IRow } from '../models';
import InviteMenu from './InviteMenu';
import { useWidth } from 'reusableComponents/useWidth';
import { Paper } from 'library';
import { track } from 'shared';

interface IProps {
    rows: IRow[];
    setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function InviteMenuPopup({ rows, setOpenMenu }: IProps) {
    const breakpoint = useWidth();
    function handleInset() {
        switch (breakpoint) {
            case 'sm':
                return '40px auto auto -150px';
            case 'md':
                return '40px auto auto -350px';
            default:
                return '40px auto auto 0px';
        }
    }

    function handleClickAway() {
        track('Group: Invite Menu Closed');
        setOpenMenu(false);
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div style={{ position: 'absolute', width: 450, paddingTop: 5, inset: handleInset() }}>
                <Paper elevation={2}>
                    <InviteMenu rows={rows} />
                </Paper>
            </div>
        </ClickAwayListener>
    );
}
